import { render, staticRenderFns } from "./manage-projects.vue?vue&type=template&id=9b283c9e"
import script from "./manage-projects.vue?vue&type=script&lang=js"
export * from "./manage-projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports